import { Icon } from '@octano/global-ui';
import { ReactElement } from 'react';

import { CourseGroupListItem } from '../types';

interface DetailTooltipCellProps {
  row: CourseGroupListItem;
  onClick: (id: number) => void;
}

/**
 * HU 15564 — Task FE-B: celda "Detalle de agrupación".
 * Muestra el conteo de items y un ícono "information" que al click abre el
 * modal de detalle (modal real implementado en Task FE-D).
 */
export default function DetailTooltipCell({
  row,
  onClick,
}: DetailTooltipCellProps): ReactElement {
  return (
    <button
      type="button"
      className="btn p-0 d-inline-flex align-items-center"
      style={{ gap: 4 }}
      onClick={() => onClick(row.id)}
    >
      <span>{row.itemCount}</span>
      <Icon name="information" size="16px" color="primary" />
    </button>
  );
}
